<template>
  <div class="libro-firmas-wrapper">
    <div ref="bienvenidaRef" class="bienvenida-container">
      
      <div class="stars-container">
        <div v-for="n in 50" :key="'s'+n" class="star" :style="generateStarStyle()"></div>
        <div v-for="n in 3" :key="'ss'+n" class="shooting-star"></div>
      </div>

      <div class="mensaje-container">
        <h2 class="titulo-libro">Libro de Firmas</h2>
        <div class="input-group">
          <textarea
            v-model="nuevoMensaje"
            placeholder="Escribe tus deseos aquí..."
            rows="4"
            maxlength="500"
            @input="verificarLongitud"
          />
          <div class="contador">
            {{ caracteresRestantes }} caracteres restantes
          </div>
        </div>

        <div class="input-group">
          <input
            v-model="localNombre"
            type="text"
            placeholder="Tu nombre..."
            class="nombre-input"
          >
        </div>

        <button class="btn-enviar" @click="enviarMensaje">
          <span>Enviar Mensaje</span>
        </button>

        <div class="mensajes-enviados" v-if="mensajes.length > 0">
          <h3>Mensajes recibidos</h3>
          <div class="scroll-mensajes">
            <div
              v-for="(mensajeObj, index) in mensajes"
              :key="index"
              class="mensaje-tarjeta"
            >
              <span class="firma-nombre">{{ mensajeObj.nombre }}</span>
              <p class="firma-texto">{{ mensajeObj.mensaje }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, nextTick, computed } from 'vue';
import axios from 'axios';
import baseUrl from '../api';
import gsap from 'gsap';

export default {
  name: 'BienvenidaPage',
  props: {
    idInvitado: { type: Number, required: true },
    nombre: { type: String, default: '' },
    idFestejado: { type: Number, default: null }
  },
  setup(props) {
    const bienvenidaRef = ref(null);
    const nuevoMensaje = ref('');
    const localNombre = ref('');
    const mensajes = ref([]);
    const maxCaracteres = 500;
    const caracteresRestantes = computed(() => maxCaracteres - nuevoMensaje.value.length);

    const generateStarStyle = () => ({
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      width: `${Math.random() * 2 + 1}px`,
      height: `${Math.random() * 2 + 1}px`,
      animationDuration: `${Math.random() * 3 + 2}s`,
      animationDelay: `${Math.random() * 5}s`
    });

    const obtenerMensajes = async () => {
      try {
        const response = await axios.get(`${baseUrl}/mensajes?idFestejado=${props.idFestejado}`);
        mensajes.value = response.data;
      } catch (error) {
        console.error('Error:', error);
      }
    };

    const enviarMensaje = async () => {
      if (nuevoMensaje.value.trim() && localNombre.value.trim()) {
        try {
          await axios.post(`${baseUrl}/mensajes`, {
            mensaje: nuevoMensaje.value.trim(),
            idFestejado: props.idFestejado,
            idInvitado: props.idInvitado,
            nombre: localNombre.value.trim(),
          });
          mensajes.value.unshift({ // Ponemos el nuevo arriba
            nombre: localNombre.value.trim(),
            mensaje: nuevoMensaje.value.trim()
          });
          nuevoMensaje.value = '';
          localNombre.value = '';
        } catch (error) {
          console.error('Error al guardar:', error);
        }
      }
    };

    onMounted(async () => {
      await obtenerMensajes();
      await nextTick();

      // Animación de entrada elegante con GSAP
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            gsap.fromTo(bienvenidaRef.value, 
              { opacity: 0, y: 50, scale: 0.9 },
              { opacity: 1, y: 0, scale: 1, duration: 1.2, ease: "power4.out" }
            );
            observer.disconnect();
          }
        });
      }, { threshold: 0.2 });

      if (bienvenidaRef.value) observer.observe(bienvenidaRef.value);
    });

    return { 
      bienvenidaRef, nuevoMensaje, localNombre, mensajes, 
      enviarMensaje, caracteresRestantes, generateStarStyle 
    };
  }
};
</script>

<style scoped>
.libro-firmas-wrapper {
  padding: 40px 15px;
  background-image: 
    linear-gradient(to bottom, 
      rgba(0, 0, 0, 0.32) 60%, 
      rgba(0, 0, 0, 0.7) 85%, 
      rgba(0, 0, 0, 0.95) 100%
    ),
    url('@/assets/fondi - copia - copia.png');
  background-size: cover;
  background-position: center center;   min-height: 60vh;  /* 👈 esto lo obliga a medir toda la pantalla */
  display: flex;
  justify-content: center;
}

.bienvenida-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  background: linear-gradient(to bottom, #000000 0%, #08062d 100%);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 30px;
  padding: 40px 20px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0,0,0,0.5);
}

/* --- ESTRELLAS --- */
.stars-container {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  z-index: 0;
  pointer-events: none;
}
.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 5px #fff;
  animation: twinkle linear infinite;
}
@keyframes twinkle {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.3); }
}

.shooting-star {
  position: absolute;
  top: 0; left: 50%; width: 2px; height: 2px;
  background: white;
  animation: shoot 4s linear infinite;
  opacity: 0;
}
@keyframes shoot {
  0% { transform: rotate(-45deg) translateX(0); opacity: 1; }
  20% { opacity: 1; }
  100% { transform: rotate(-45deg) translateX(-500px); opacity: 0; }
}

/* --- FORMULARIO --- */
.mensaje-container {
  position: relative;
  z-index: 2;
}

.titulo-libro {
  font-family: 'Playfair Display', serif;
  color: #fff;
  font-size: 32px;
  margin-bottom: 30px;
  text-shadow: 0 0 10px rgba(255,255,255,0.3);
}

.input-group {
  margin-bottom: 20px;
  text-align: left;
}

textarea, .nombre-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 15px;
  padding: 15px;
  font-family: 'Segoe UI', sans-serif;
  font-size: 15px;
  color: #333;
  box-shadow: inset 0 2px 5px rgba(0,0,0,0.1);
  transition: all 0.3s;
}

textarea:focus, .nombre-input:focus {
  transform: translateY(-2px);
  background: #fff;
  box-shadow: 0 5px 15px rgba(255,255,255,0.2);
}

.contador {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  margin-top: 5px;
  padding-left: 5px;
}

/* --- BOTÓN --- */
.btn-enviar {
  width: 100%;
  padding: 15px;
  border-radius: 50px;
  border: none;
  background: linear-gradient(45deg, #120b3a, #4b32a1);
  color: white;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 10px;
}

.btn-enviar:hover {
  transform: scale(1.02);
  box-shadow: 0 0 20px rgba(75, 50, 161, 0.6);
}

/* --- LISTA DE MENSAJES --- */
.mensajes-enviados {
  margin-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
}

.mensajes-enviados h3 {
  color: #fff;
  font-size: 18px;
  margin-bottom: 15px;
  font-family: 'Playfair Display', serif;
}

.scroll-mensajes {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 10px;
}

/* Custom Scrollbar */
.scroll-mensajes::-webkit-scrollbar {
  width: 4px;
}
.scroll-mensajes::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.2);
  border-radius: 10px;
}

.mensaje-tarjeta {
  background: linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05));
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 12px;
  text-align: left;
}

.firma-nombre {
  display: block;
  color: #a48250; /* Color dorado del resto de la invitación */
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 5px;
}

.firma-texto {
  color: #efefef;
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
}
</style>